import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { createI18nWrapper } from './i18next';

export const useI18n = () => {
  const { i18n } = useTranslation('translation');

  // i18n.language changes on language switch but the i18n object reference
  // stays stable. Include language to bust useMemo caches downstream.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => createI18nWrapper(() => i18n), [i18n, i18n.language]);
};

export { I18nextProvider, Trans } from 'react-i18next';
